var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 15.333,
    fill: "#92FBD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.195 31.75-6.018-6.019a10.533 10.533 0 0 0 1.615-5.617c0-5.844-4.736-10.579-10.58-10.579-5.843 0-10.575 4.738-10.575 10.579 0 5.844 4.735 10.579 10.579 10.579a10.55 10.55 0 0 0 6.043-1.896l5.946 5.949c.396.396.936.62 1.496.617.561 0 1.1-.22 1.497-.617a2.12 2.12 0 0 0-.003-2.996zm-14.98-4.485a7.152 7.152 0 1 1 .002-14.304 7.152 7.152 0 0 1-.001 14.304z",
    fill: "#14CC81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSearch);
export default __webpack_public_path__ + "static/media/homeSearch.e46beced5ef54c60c1dbfd8eeee45e16.svg";
export { ForwardRef as ReactComponent };